function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWave9(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "f61944af-58e1-4351-8594-f145280d4fd9",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1366 48"
  }, props), /*#__PURE__*/React.createElement("g", {
    id: "fa17dfc7-5401-4937-a21b-2c8ea130efaa",
    "data-name": "Wave-7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a2e7f7f8-cb60-4462-8980-21ef570bccca",
    "data-name": "Rectangle",
    d: "M1366,0C743,0,667,37.76482,0,48H1366Z",
    style: {
      fill: "currentColor",
      fillRule: "evenodd"
    }
  })));
}

export default SvgWave9;